import type { PropsWithChildren } from "react";
import { createContext } from "react";
import type { InvestorCommunicationInfo } from "../../../api/types/investorCommunicationsTypes";
import type { InvestorCommunicationStatusTransition } from "./investorCommunicationStatusHelper";

interface Props {
  hasEditPermissions: boolean;
  isNewsVisibleToInvestors: boolean;
  onCreate: () => void;
  onStatusChange: (
    communication: InvestorCommunicationInfo,
    statusTransition: InvestorCommunicationStatusTransition
  ) => void;
  onDelete: (communication: InvestorCommunicationInfo) => void;
}

const InvestorCommunicationsPageContext = createContext<Props | undefined>(undefined);

export const InvestorCommunicationsPageContextProvider = ({ children, ...contextValue }: PropsWithChildren<Props>) => (
  <InvestorCommunicationsPageContext value={contextValue}>{children}</InvestorCommunicationsPageContext>
);

export default InvestorCommunicationsPageContext;
